<template>
    <section class="mb-0 border round bg-white">
        <transition-group name="slide">
            <div
                v-if="contractSelected && schoolSelected"
                :key="
                    'school-contract-selected' +
                    (contractSelected ? contractSelected['con_no'] : '')
                "
                class="px-3 py-2 position-relative justify-content-between round d-flex flex-wrap"
            >
                <div
                    v-if="
                        schoolSelected['schnum'] && contractSelected['con_no']
                    "
                    class="animated fadeIn"
                >
                    <b>{{ titleCase(schoolSelected.sch_name) }}</b>
                    {{ titleCase(schoolSelected.county) }},
                    {{ schoolSelected.state }} #{{ schoolSelected.schnum }}
                    <div>
                        {{ contractSelected.school_year }}
                        {{ seasonsLookup[contractSelected.season] }} -
                        {{ titleCase(contractSelected.description) }} C{{
                            contractSelected["con_no"]
                        }}
                    </div>
                </div>

                <div v-else></div>

                <button
                    class="btn btn-basic"
                    @click.prevent="clearSelectedContract"
                >
                    <span class="mr-2">Change School Contract</span>
                    <i
                        class="fa fa-caret-down bg-gray-300"
                        style="
                            width: 30px;
                            height: 30px;
                            border-radius: 100%;
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                        "
                    />
                </button>
            </div>

            <div
                v-if="schoolSelected && !showContract"
                :key="
                    'school-selected' +
                    (schoolSelected ? schoolSelected['schnum'] : '')
                "
                class="px-3 py-2 position-relative justify-content-between round d-flex flex-wrap"
            >
                <div
                    v-if="schoolSelected['schnum']"
                    class="animated fadeIn d-flex"
                >
                    <div style="align-self: center">
                        <b>{{ titleCase(schoolSelected.sch_name) }}</b>
                        {{ titleCase(schoolSelected.county) }},
                        {{ schoolSelected.state }} #{{ schoolSelected.schnum }}
                    </div>
                </div>

                <div v-else></div>

                <button
                    class="btn btn-basic text-secondary"
                    @click.prevent="clearSelectedSchool"
                >
                    <i class="fa fa-chevron-down mr-1" />Change School
                </button>
            </div>

            <div
                class=""
                v-if="(!contractSelected && showContract) || !schoolSelected"
                :key="
                    'school-contract-selector' +
                    (contractSelected ? contractSelected['con_no'] : '')
                "
            >
                <div class="card-body">
                    <div class="split-viewer">
                        <!-- USER SCHOOLS -->
                        <div
                            :class="[
                                'left-side col-12',
                                schoolSelected && showContract
                                    ? 'col-sm-6'
                                    : '',
                            ]"
                        >
                            <div
                                class="d-flex justify-content-between align-items-center px-md-4 px-sm-3 px-2 pt-3"
                            >
                                <h3
                                    class="animated fadeIn font-header"
                                    style="font-weight: 400"
                                    :key="
                                        'sch-con-sel-title' +
                                        (schoolSelected
                                            ? schoolSelected.schnum
                                            : '')
                                    "
                                >
                                  <span v-if="title">{{title}}</span>
                                  <span v-else>
                                    Select a School <span v-if="showContract">{{schoolSelected ? " Contract" : " or Contract" }}</span>
                                  </span>
                                </h3>
                                <!--<button class="btn btn-basic text-secondary p-0" @click.prevent="close" title="Close Contract Selector">
									<i class="fa fa-times-circle mr-1" /><b>Close</b>
								</button>-->
                            </div>
                            <!--<div class="d-flex py-2 px-3 align-items-baseline border-bottom">
								<h4 class="mb-0 mr-2">
									<i class="fa fa-school mr-2 text-muted" />My Schools
								</h4>
								{{userSchools.length}} total
							</div>

							<div>
								<ul style="max-height: 340px; overflow-x:hidden;overflow-y:auto" class="list-group">

									<li v-for="(row, index) in userSchools" :key="'userSchool'+row.schnum+index"
									@click.prevent="selectSchool(row)"
									:class="['list-group-item', schoolSelected && row.schnum == schoolSelected.schnum ? 'active' : '']">
										<b>{{titleCase(row.school_name)}}</b> #{{row.schnum}} <span> {{row.city ? titleCase(row.city) + ', ' : titleCase(row.county) + ', '}} {{row.state}}</span>
									</li>
								</ul>
							</div>-->

                            <div
                                class="school-search-wrapper w-100 p-md-3 p-sm-1 p-0 mt-sm-3 my-1 mb-3 mb-md-0 d-flex align-items-center"
                            >
                                <!--Search
								v-on:result="selectSchoolResult"
								v-on:search="searchSchools"
								listId="schol-con-selector-school-list"
								text="Search Schools / Select School"
								:inputId="'school-con-selector-input'+ (schoolSelected ? schoolSelected['schnum'] : '')"
								:layout="`'schnum': 'sch_name' ('county', 'state')`"
								:results="schoolResults">
								</Search-->
                                <i class="fa fa-search mr-2 fa-lg text-muted" />
                                <SchoolContractSearch
                                    v-on:result="selectSchoolContractResult"
                                    v-on:search="searchSchoolsContracts"
                                    listId="schol-con-selector-school-list"
                                    :text="
                                        'Search Schools' +
                                        (showContract ? ' and Contracts' : '')
                                    "
                                    :results="searchResults"
                                >
                                </SchoolContractSearch>
                            </div>

                            <div
                                v-if="schoolSelected"
                                class="mx-0 mx-md-3 mx-sm-1"
                            >
                                <div class="m-1">School selected:</div>
                                <div
                                    class="p-2 p-sm-3 bg-gray-100 border-light rounded-sm mb-3"
                                >
                                    <h5 class="m-0">
                                        <b
                                            >{{
                                                titleCase(
                                                    schoolSelected.sch_name
                                                )
                                            }}
                                            #{{ schoolSelected.schnum }}</b
                                        >
                                    </h5>
                                    <div>
                                        {{ titleCase(schoolSelected.street) }}
                                    </div>
                                    <div>
                                        {{ titleCase(schoolSelected.city) }},
                                        {{ schoolSelected.state }}
                                    </div>
                                    <div>
                                        {{
                                            schoolSelected["county"]
                                                ? titleCase(
                                                      schoolSelected.county
                                                  ) + " County"
                                                : ""
                                        }}
                                    </div>
                                </div>
                                <div>
                                    <button
                                        class="btn btn-link text-dark"
                                        @click.prevent="clearSelectedSchool"
                                    >
                                        <i
                                            class="fa fa-times-circle mr-2"
                                        />Clear selected school.
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div
                            class="right-side col-12 col-sm-6"
                            v-if="schoolSelected && showContract"
                        >
                            <!--<h3 style="font-weight:300;text-align:center" v-if="schoolSelected">
								Choose a contract for {{schoolSelected.school_name}}
							</h3>-->
                            <!-- Contracts Title -->
                            <div
                                v-if="schoolContracts"
                                class="d-flex align-items-center border-bottom pb-2"
                            >
                                <i
                                    class="fa fa-receipt mr-2 fa-lg text-secondary"
                                />
                                <h5
                                    class="mb-0 mr-2 d-flex align-items-center"
                                    style="font-weight: 400"
                                >
                                    <b
                                        >{{ schoolContracts.length }} contract{{
                                            schoolContracts.length == 1
                                                ? ""
                                                : "s"
                                        }}</b
                                    >&nbsp;&nbsp;
                                    <div class="font-sm text-secondary">
                                        {{
                                            titleCase(
                                                schoolSelected.school_name
                                            )
                                        }}
                                    </div>
                                </h5>
                            </div>

                            <div
                                v-if="yearlist"
                                class="py-3 d-flex flex-wrap align-items-center font-lg text-secondary"
                            >
                                <div
                                    v-for="(year, i) in yearlist"
                                    :key="'yrlist' + i"
                                    class="d-flex align-items-center custom-control custom-radio pl-0 pr-2 mb-2 mb-lg-0"
                                >
                                    <input
                                        type="radio"
                                        :name="'year' + i"
                                        :id="'year' + i"
                                        v-model="yearSelected"
                                        :value="year"
                                        class="custom-control-input"
                                    />
                                    <label class="m-0 p-0 bg-gray-100 round border px-3 cursor-pointer"
                                           :class="{'font-weight-bold text-primary border-primary':yearSelected && yearSelected === year}"
                                           :for="'year' + i"
                                           @click="selectYear(year)">
                                        {{ year.replace("-", " - ") }}
                                    </label>
                                </div>
                            </div>

                            <!-- SCHOOL CONTRACTS -->
                            <div
                                v-if="
                                    schoolSelected &&
                                    schoolContracts &&
                                    schoolContracts.length > 0 &&
                                    hideContractsArea !== true
                                "
                            >
                                <ul
                                    style="
                                        max-height: 230px;
                                        overflow-x: hidden;
                                        overflow-y: auto;
                                    "
                                    class="list-group"
                                >
                                    <li
                                        v-for="(row, index) in schoolContracts"
                                        :key="'schoolContracts' + index"
                                        v-if="yearSelected == row.school_year"
                                        @click.prevent="selectContract(row)"
                                        style="color: var(--primary)"
                                        :title="row.records + ' Records Found'"
                                        :class="[
                                            'list-group-item px-1 d-flex flex-wrap justify-content-between align-items-center',
                                            contractSelected &&
                                            row.contract_id ==
                                                contractSelected.contract_id
                                                ? 'active'
                                                : '',
                                        ]"
                                    >
                                        <div class="font-lg">
                                            <small
                                                v-if="
                                                    row['season'] &&
                                                    seasonsLookup[row.season]
                                                "
                                                ><b>{{
                                                    seasonsLookup[
                                                        row.season
                                                    ].toUpperCase()
                                                }}</b></small
                                            >
                                            {{ titleCase(row.description) }}
                                        </div>
                                        <div class="d-flex">
                                            <div class="mr-2">
                                                C{{ row.contract_id }}
                                            </div>
                                            <div
                                                class="font-xs bg-light border border-light round text-secondary px-2 py-0"
                                            >
                                                {{ row.records }}
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <!--<div v-if="schoolSelected && schoolContracts && schoolContracts.length == 0">
								No contracts were found for {{schoolSelected.school_name}}
							</div>-->
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import School from "../classes/School";
import SchoolContract from "../classes/SchoolContract";
import User from "../classes/Admin/User";

import SchoolContractSearch from "./app/SchoolContractSearch";

export default {
    props: ["title", "pShowContract", "pHideContractsArea"],

    data() {
        return {
            userSchools: null,
            schoolContracts: null,
            schoolSelected: null,
            contractSelected: null,
            seasonsLookup: {
                S: "Spring",
                F: "Fall",
            },
            schoolResults: null,
            searchResults: null,
            SchoolContract: new SchoolContract(),
            showContract: this.pShowContract === false ? false : true,
            yearlist: [],
            yearSelected: "",
            currentYear: "",
            hideContractsArea: this.pHideContractsArea,
        };
    },

    components: {
        SchoolContractSearch,
    },

    beforeMount() {
        this.checkApplicationStorage();
    },

    mounted() {
        let self = this;
        if (!this.schoolSelected) {
            this.$nextTick(function () {
                self.getUserSchools();
            });
        }
    },

    watch: {
      yearSelected(newValue, oldValue)  {
        this.selectYear(newValue);
      },
    },

    methods: {

      selectYear(year) {
        let self = this;
        this.$nextTick(function () {
          self.$emit("selectYear", year);
        });
      },

        close() {
            this.$emit("close");
        },

        checkApplicationStorage() {
            /* app school */
            var school = this.getAppSchool();
            if (school) {
                this.selectSchool(school);
            }
            /* app contract */
            if (this.showContract) {
                var contract = this.getAppContract();
                if (contract) {
                    this.selectContract(contract);
                }
            }
        },

        async searchSchools(search) {
            var _school = new School();
            var data = {
                search: search,
            };
            var self = this;
            _school.searchSchools(data).then(function (response) {
                self.schoolResults = response.data;
            });
        },

        // async searchSchoolsContracts(search) {
        // 	var _school = new School()
        // 	var data = {
        // 		search: search
        // 	}
        // 	var self = this
        // 	_school.searchSchools(data).then(function(response) {
        // 		self.schoolResults = response.data
        // 	})
        // },

        async getUserSchools() {
            let self = this;
            this.userSchools = null;
            var _user = new User(this.$auth.user().details.id);
            _user.getUserSchools().then(function (response) {
                if (!response || response.status != 200) {
                    return;
                }

                self.userSchools = response.data;

                if (response["data"] && response.data.length == 1) {
                    self.selectSchool(response.data[0]);
                    if (this.showContract)
                        self.getSchoolContracts(response.data[0]["schnum"]);
                }
            });
        },

        selectSchoolResult(index) {
            var school = this.schoolResults[index];
            var schoolWasChanged =
                this.schoolSelected &&
                this.schoolResults[index]["schnum"] !==
                    this.schoolSelected["schnum"];
            if (schoolWasChanged) this.clearSelectedContract();
            this.selectSchool(school);
        },

        async selectSchool(school) {
            this.schoolSelected = school;
            if (
                this.getAppSchool() &&
                this.getAppSchool()["schnum"] !== school.schnum
            ) {
                this.clearSelectedContract();
            }
            /* school details */
            await this.getSchoolDetails(school.schnum);
            /* get contracts */
            this.getSchoolContracts(school.schnum);
        },

        clearSelectedSchool() {
            this.schoolSelected = null;
            
            /* sessionStorage */
            sessionStorage.removeItem('schoolSelected')
            sessionStorage.removeItem('school_id')
            sessionStorage.removeItem('school_name')
            sessionStorage.removeItem('school_location')
            sessionStorage.removeItem('contract_id')
            /* localStorage */
            localStorage.removeItem('schoolSelected')
            localStorage.removeItem('school_id')
            localStorage.removeItem('school_name')
            localStorage.removeItem('school_location')
            localStorage.removeItem('contract_id')

            window.events.$emit("contractSelected", null);
            window.events.$emit("schoolSelected", null);
            this.$emit("selectSchool", null);
            this.$emit("selectContract", null);
        },

        getSchoolDetails(schnum) {
            var self = this;
            var _school = new School();
            _school.getDetails({ schnum: schnum }).then(function (response) {
                if (
                    !response ||
                    !response["data"] ||
                    response["status"] !== 200
                ) {
                    self.clearSelectedSchool();
                    return;
                }

                var school = response.data;
                school["school_name"] = school.sch_name;

                /* emit to window to keep schoolSelected in sync */
                self.schoolSelected = school;
                window.events.$emit("schoolSelected", school);
                self.$nextTick(function () {
                    self.$emit("selectSchool", school);
                });
            });
        },

        selectContract(contract) {
            this.setContract(contract);

            if (this.schoolSelected) {
                window.events.$emit("schoolSelected", this.schoolSelected);
                this.$emit("selectSchool", this.schoolSelected);
            }

            window.events.$emit("contractSelected", contract);
            var self = this;
            this.$nextTick(function () {
                self.$emit("selectContract", contract);
            });
        },

        setContract(contract) {
            if (
                !contract ||
                (!contract["contract_id"] && !contract["con_no"])
            ) {
                return;
            }

            if (contract && contract["contract_id"])
                contract["con_no"] =
                    contract.contract_id; /* add the con_no attribute. never should have been contract_id */
            this.contractSelected = contract;
        },

        clearSelectedContract() {
            this.contractSelected = null;

            /* sessionStorage */
            sessionStorage.removeItem('contract_id')
            sessionStorage.removeItem('contractSelected')
            /* localStorage */
            localStorage.removeItem('contract_id')
            localStorage.removeItem('contractSelected')

            window.events.$emit("contractRemoved");
            this.$emit("selectContract", null);
        },

        async getSchoolContracts(schnum) {
            if (!schnum) return;

            const self = this;
            var _school = new School();

            await self.getCurrentYear();

            _school.getContracts(schnum).then(function (response) {
                if (
                    !response ||
                    !response["data"] ||
                    response["status"] !== 200
                ) {
                    self.schoolContracts = null;
                    return;
                }
                self.schoolContracts = response.data;

                if (self.$route.name === 'contracts.upload') {
                  self.getSchoolYearList(schnum);
                } else {
                  self.yearlist = self.getContractYears(self.schoolContracts);
                  self.markCurrentYear();
                }
            });
        },

        getContractYears(contracts) {
            var yearlist = [];
            var self = this;
            contracts.forEach((row) => {
                if (!yearlist.includes(row.school_year)) {
                    yearlist.push(row.school_year);
                }
            });
            yearlist.sort().reverse();
            return yearlist;
        },

      getSchoolYearList(schoolNumber) {
        if (!schoolNumber) {
          return;
        }

        let self = this;
        let _school = new School();
        _school.getSchoolYearList(schoolNumber).then(function (response) {
          if (!response || !response["data"] || response["status"] !== 200) {
            return [];
          }

          self.yearlist = response["data"].data.sort().reverse();

          self.markCurrentYear();
        });

        return [];
      },

      markCurrentYear()
      {
        let self = this;
        if (self.yearlist.length > 0) {
          if (self.yearlist.includes(self.currentYear)) {
            self.yearSelected = self.currentYear;
          } else {
            self.yearSelected = self.yearlist[0];
          }
        }
      },

        searchSchoolsContracts(search) {
            let self = this;
            var data = {
                search: search,
                user_id: this.$auth.user().details.id,
            };
            this.SchoolContract.search(data).then(function (response) {
                if (self.showContract) {
                    self.searchResults = response.data;
                } else {
                    var schools = [];
                    response.data.forEach(function (row) {
                        if (row.result_type == "school") {
                            schools.push(row);
                        }
                    });
                    self.searchResults = schools;
                }
            });
        },

        selectSchoolContractResult(index) {
            var sc = this.searchResults[index];

            this.clearSelectedSchool();

            var schoolWasChanged =
                this.schoolSelected &&
                this.searchResults[index]["schnum"] !==
                    this.schoolSelected["schnum"];
            if (schoolWasChanged) {
                this.clearSelectedContract();
            }
            this.selectSchool(sc);

            if (sc.result_type === "contract") {
                this.selectContract(this.searchResults[index]);
            }
        },
        getCurrentYear() {
            var self = this;
            var _school = new School();
            _school.getCurrentYear().then(function (response) {
                if (
                    !response ||
                    !response["data"] ||
                    response["status"] !== 200
                ) {
                    return;
                }

                self.currentYear = response["data"];
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.list-group-item {
    cursor: pointer;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    padding: 6px 1.5rem;
    background: none;
    border-color: var(--secondary);

    &.active {
        background: var(--primary);
        color: #fff !important;
    }

    &:hover {
        background: var(--primary);
        color: var(--light) !important;
    }
}

:deep .split-viewer {
    display: flex;
    flex-wrap: wrap;

    .title {
        padding: 8px 1.5rem;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
        align-items: flex-end;
    }

    .right-side {
        background: #fff;
        padding: 1rem;
        flex-grow: 1;
        border-left: 1px solid var(--secondary);
    }
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-enter-active {
    transition: all 0.23s ease-in;
}
.slide-leave-active {
    transition: all 0.23s ease-in;
}
.slide-enter {
    transform: translateY(-100%);
}
.slide-leave-to {
    opacity: 0;
    transform: translateY(100%);
}

.card-body {
    margin: 0;
    padding: 10px !important;
}

@media screen and (max-width: 486px) {
    .left-side {
        padding: 5px 7px !important;
    }
}

@media screen and (max-width: 960px) {
    h4 {
        font-size: 1.2rem;
    }

    h5 {
        font-size: 1rem;
    }

    .card-body {
        margin: 0;
        padding: 0 !important;
    }

    .list-group-item {
        padding: 3px 5px !important;
    }
}
</style>
